import { render, staticRenderFns } from "./QuestionnaireModal.vue?vue&type=template&id=3112549a&"
import script from "./QuestionnaireModal.vue?vue&type=script&lang=js&"
export * from "./QuestionnaireModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports